import { CurrentCampaign } from "../../types/apiTypes";
import { NoUploadDataBlock } from "./NoUploadDataBlock";
import { NoContactsDataBlock } from "./NoContactsDataBlock";
import { NoAnalysedDataBlock } from "./NoAnalysedDataBlock";
import { StatisticsBlock } from "./StatisticsBlock";

export const Statistics = ({
  data,
  campaign_id,
}: {
  data: CurrentCampaign;
  campaign_id: string;
}) => {
  const { total_accounts, total_accounts_analyzed, has_contacts } = data;

  if (!total_accounts) {
    return (
      <NoUploadDataBlock
        campaign_id={campaign_id}
        totalAccounts={total_accounts}
      />
    );
  }

  if (!has_contacts) {
    return (
      <NoContactsDataBlock
        campaign_id={campaign_id}
        totalAccounts={total_accounts}
      />
    );
  }

  if (!total_accounts_analyzed) {
    return (
      <NoAnalysedDataBlock
        campaign_id={campaign_id}
        totalAccounts={total_accounts}
      />
    );
  }

  return <StatisticsBlock campaign={data} />;
};
